module.exports = __webpack_public_path__ + "static/media/01-homepage.d5a85601.png";